import { TableColumn } from 'liyu-pc-base/typing';
import { Record, SearchConfig } from 'liyu-pc-base/components/remotePages/typing';

import { reactive } from 'vue';

export default () => {
  const search_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'inline',
    },
    fields: [
      {
        type: 'input',
        name: 'name',
        label: '名称',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '请填写名称',
      },
      {
        type: 'input',
        name: 'corpid',
        label: 'CorpID',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '请填写CorpID',
      },
      {
        type: 'input',
        name: 'appid',
        label: 'APPID',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '请填写APPID',
      },

      {
        type: 'input',
        name: 'appkey',
        label: 'APPKey',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '请填写APPKey',
      },
      {
        type: 'input',
        name: 'appsecret',
        label: 'APPSecret',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '请填写APPSecret',
      },
      {
        type: 'radio',
        name: 'is_active',
        label: '状态',
        mode: 'default',
        disabled: false,
        defaultValue: '',
        labelKey: 'name',
        valueKey: 'value',
        placeholder: '请选择状态',
        datasource: 'is_active',
      },
    ],
    rules: {},
    model: reactive({
      name: '',
      appid: '',
      corpid: '',
      appkey: '',
      appsecret: '',
    }),
    options: {
      is_active: [
        { name: '全部', value: '' },
        { name: '正常', value: true },
        { name: '作废', value: false },
      ],
    },
  };

  const edit_model_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'horizontal',
      col: [],
    },
    fields: [
      {
        type: 'input',
        name: 'name',
        label: '名称',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '请填写名称',
      },
      {
        type: 'input',
        name: 'corpid',
        label: 'CorpID',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '请填写CorpID',
      },
      {
        type: 'input',
        name: 'appid',
        label: 'APPID',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '请填写APPID',
      },
      {
        type: 'input',
        name: 'appkey',
        label: 'APPKey',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '请填写APPKey',
      },
      {
        type: 'input',
        name: 'appsecret',
        label: 'APPSecret',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '请填写APPSecret',
      },
    ],
    rules: {
      name: [{ required: true, message: '请输入名称' }],
      corpid: [{ required: true, message: '请填写CorpID' }],
      appid: [{ required: true, message: '请填写APPID' }],
      appkey: [{ required: true, message: '请填写APPKey' }],
      appsecret: [{ required: true, message: '请填写APPSecret' }],
    },
    model: {
      name: '',
      corpid: '',
      appid: '',
      appkey: '',
      appsecret: '',
    },
    options: {},
  };

  const update_model_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'horizontal',
      col: [],
    },
    fields: [
      {
        type: 'input',
        name: 'name',
        label: '名称',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '请填写名称',
      },
      {
        type: 'input',
        name: 'corpid',
        label: 'CorpID',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '请填写CorpID',
      },
      {
        type: 'input',
        name: 'appid',
        label: 'APPID',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '请填写APPID',
      },
      {
        type: 'input',
        name: 'appkey',
        label: 'APPKey',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '请填写APPKey',
      },
      {
        type: 'input',
        name: 'appsecret',
        label: 'APPSecret',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '请填写APPSecret',
      },
    ],
    rules: {
      name: [{ required: true, message: '请输入名称' }],
      corpid: [{ required: true, message: '请填写CorpID' }],
      appid: [{ required: true, message: '请填写APPID' }],
      appkey: [{ required: true, message: '请填写APPKey' }],
      appsecret: [{ required: true, message: '请填写APPSecret' }],
    },
    model: reactive({
      name: '',
      corpid: '',
      appid: '',
      appkey: '',
      appsecret: '',
    }),
    options: {},
  };

  const titleList = {
    title: '钉钉管理',
    addModalTitle: '新建钉钉信息',
    updateTitle: '修改',
    is_create: true, // 是否有【新建】按钮
    is_update: true, // 是否有【修改】按钮
    is_remove: true, // 是否有【删除】按钮
    is_recover: true, // 是否有【恢复】按钮
  };

  const api_fields: Record = {
    update: {
      token_id: 'id',
    },
    delete: {
      token_id: 'id',
    },
    recover: {
      token_id: 'id',
    },
    updateData: {
      token_id: 'id',
    },
  };

  const baseColumns: TableColumn[] = [
    {
      title: '序号',
      width: 50,
      dataIndex: 'index',
      checked: true,
      fixed: 'left',
    },
    {
      title: '名称',
      width: 150,
      dataIndex: 'name',
      checked: true,
      fixed: 'left',
    },

    {
      title: 'CorpID',
      dataIndex: 'corpid',
      checked: true,
    },
    {
      title: 'APPID',
      dataIndex: 'appid',
      checked: true,
    },
    {
      title: 'APPKey',
      dataIndex: 'appkey',
      checked: true,
    },
    {
      title: 'APPSecret',
      dataIndex: 'appsecret',
      checked: true,
    },

    {
      title: 'PC端首页地址',
      dataIndex: 'pcurl',
      checked: true,
    },

    {
      title: '是否可用',
      width: 100,
      dataIndex: 'is_active',
      checked: true,
      resizable: true,
      cellComponent: 'boolean',
      name1: '可用',
      name2: '禁用',
      filterMultiple: false,
      filters: [
        { text: '全部', value: '' },
        { text: '可用', value: 'true' },
        { text: '禁用', value: 'false' },
      ],
    },
    {
      title: '操作',
      checked: true,
      width: 50,
      dataIndex: 'action',
      cellComponent: 'action',
      fixed: 'right',
    },
  ];
  return {
    searchConfig: search_config,
    formModalConfig: edit_model_config,
    updateFormModalConfig: update_model_config,
    queryData: '/dd/query_ding_appinfo_list',
    addData: '/dd/create_ding_appinfo',
    updateData: '/dd/update_ding_appinfo',
    removeData: '/dd/delete_ding_appinfo',
    recoverData: '/dd/recover_ding_appinfo',
    baseColumns: baseColumns,
    titleList: titleList,
    api_fields: api_fields,
    base_search_condition_config_list: [],
    default_search_condition_config_list: [[]],
    condition_group_config_list: [],
    is_show_advantage: false,
    is_show_normal_search: true,
    is_only_show_advantage: false,
    is_only_show_normal_search: true,
    queryConditionGroupData: null,
    isView: false,
    is_pagination: false,
  };
};
